import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Field } from "react-final-form";
import renderSelectField from "@easydev/form/Select";
import FormTextField from "@components/Shared/FormTextField";
import ButtonContainer from "@components/ButtonContainer";
import WebIcon from "mdi-react/WebIcon";
import IdentifierIcon from "mdi-react/IdentifierIcon";
import FormTextboxIcon from "mdi-react/FormTextboxIcon";
import ImageFilterDramaIcon from "mdi-react/ImageFilterDramaIcon";
import IProject from "@interfaces/Core/ProjectManager/project";
import IFormProps from "@interfaces/Shared/formProps";
import useSelectClients from "@hooks/Security/Clients/useSelectClients";
import selectClientMapper from "@mappers/Security/Clients/selectClient.mapper";

interface IModifyForm extends IFormProps {
  data: IProject;
}

const ModifyProjectForm = ({ handleSubmit, data }: IModifyForm) => {
  const { t } = useTranslation(["core"]);
  const { clientsValues } = useSelectClients();
  const [clientSelected] = useState(
    data?.clientId && selectClientMapper(data.client)
  );

  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("core:common.client")}
        </span>
        <div className="form__form-group-field">
          <Field
            name="client"
            component={renderSelectField}
            type="text"
            placeholder={`${t("core:common.select_placeholder")} ${t(
              "core:common.client"
            )}`}
            options={clientsValues}
            initialValue={clientSelected}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">{t("core:common.name")}</span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <FormTextboxIcon />
          </div>
          <Field
            name="name"
            component={FormTextField}
            type="text"
            placeholder="Client name"
            initialValue={data?.name}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">{t("core:common.key")}</span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <IdentifierIcon />
          </div>
          <Field
            name="key"
            component={FormTextField}
            type="text"
            placeholder="PROJECTKEY"
            initialValue={data?.key}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("core:common.url_image")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <ImageFilterDramaIcon />
          </div>
          <Field
            name="logoUrl"
            component={FormTextField}
            type="text"
            placeholder="https://www.nftstudios.io/images/Avatar-Profile.png"
            initialValue={data?.logoUrl}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("core:common.url_website")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <WebIcon />
          </div>
          <Field
            name="websiteUrl"
            component={FormTextField}
            type="text"
            placeholder="https://www.nftstudios.io/"
            initialValue={data?.websiteUrl}
            isAboveError
          />
        </div>
      </div>

      <ButtonContainer />
    </form>
  );
};

export default ModifyProjectForm;
